import {HttpHeader} from "../http-header/http-header";

/**
 * Class to prepare http response object
 */
export class HttpResponse {

  status: number;
  statusText: string;
  headers?: HttpHeader[];

  private body: any;

  /**
   * constructor to initialise the data members for http response object
   * @param resp - Response object from the http request
   * @param text - text for the status response
   * ```
   * @example
   * httpResponse = new HttpRespose(resp, 'Ok')
   * ```
   */
  constructor(resp: Response, text: any) {
    this.status = resp.status;
    this.statusText = resp.statusText;
    this.body = text;
  }

  /**
   * methohd to parse the http response into a json onbject
   * ```
   * @example
   * const dataResponse = this.data()
   * ```
   */
  public get data() : any {
    return this.toJson(this.body);
  }

  /**
   * Method to return string response from a method call
   * @returns - stringfied values for a http response
   * ```
   * @example
   * const responseString = this.string();
   * ```
   */
  toString(): string {
    return `HttpResponse ${this.status}(${this.statusText}) data: ${this.data}`
  }

  /**
   * Method to convert respone to json
   * @param value - is the object value to be parsed to json
   * @returns - parsed json of the value passed
   * ```
   * @example
   * const jsonResponse = this.toJson(valueObject)
   * ```
   */
  private toJson(value: any): any {
    if (value === null || value === undefined) {
      return value;    }

    if (typeof value !== 'object') {
      return value;    }

    for (const key of Object.keys(value)) {
      const v = value[key];
      if (typeof v === 'object') {
        this.toJson(v);
      }
    }
    return value;
  }
}
